const SHARED_PAY_METHOD_LABELS = {
  agent_account: "Cash Account",
  voucher_account: "Referral Bonus Account",
  gold_account: "Gold Account",
  alipay_code: "Fee Payment - Alipay",
  wechat_code: "Fee Payment - WeChat",
  pos: "POS Payment",
  mixue_alipay_code: "Alipay",
  mixue_wechat_code: "WeChat",
  bank_pay: "Bank Transfer",
  consulting_fee_pay: "Consulting Fee Deduction",
  refund_consulting_fee_non_opened_campus:
    "Consulting Fee Refund (Pre-Opening Learning Center)",
  refund_consulting_fee_opened_campus:
    "Consulting Fee Refund (Operational Learning Center)",
  pine_nut_pay: "Pine Nut Deduction",
  online_student_tuition: "Online Student Tuition",
  squirrel_consulting_fee: "Squirrel Ai Consulting Fee",
  fees_unconverted_pine_nut: "Unconverted Pine Nut Class Fees",
  squirrel_class_fee: "Squirrel Ai Class Fee",
  operation_quality_education_fee: "Quality Education Fee (Operations)",
  transfer_pay: "Referral Fee for Learning Center Expansion",
  introduction_learning_machine_transfer: "Referral Fee for Learning Tablet Expansion",
  expansion_counter_subsidy_fee: "Expansion Counter Subsidy",
  regional_release_pay: "Regional Guarantee Release Payment",
  agreement_pay: "Supplementary Agreement Grant (Expansion)",
  other_operating_expenses: "Other Operating Expenses",
  other_expenses_expansion: "Other Expansion Expenses",
  squirrel_other_expenses: "Other Squirrel Ai Expenses",
  operating_card_payment: "Education Card Payment (Operations)",
  release_money: "Guarantee Release Amount",
  base_school_repayment: "Base School Repayment",
  increased_amount_of_pine_nuts: "Pine Nut Increase Amount",
  reward_amount: "Reward Amount",
  cash_amount: "Cash Amount",
  cash_back_amount_card: "Subscription Card Cashback Amount",
  return_amount_other: "Other Rebate Amount",
  share_bonus: "Referral Bonus",
  regional_agent_cash_back: "Regional Master Franchisee Cashback",
  collection_on_delivery: "Cash on Delivery",
  region_service_charge: "Regional Service Fee",
  activate_reward: "Activation Reward",
  deposit_reward_purchase_voucher: "Deposit Reward – Purchase Voucher",
  member_awards: "Member Reward",
  collection_on_delivery_reward: "Cash on Delivery – Non-Cash Reward",
  collection_on_delivery_cash: "Cash on Delivery – Cash",
  recharge_underwriting_policy: "Underwriting Policy Recharge",
  agency_price_difference: "Agency Price Difference",
  collection_on_delivery_fission: "Cash on Delivery – Fission Bonus",
  venue_order_payment: "Event Order Payment",
  hardware_cost: "Hardware Cost",
  cash_amount_account_fee: "Account Fee (Cash Amount)",
  cash_payment: "Cash Payment",
  other: "Other",
};

export default {
  finance: {
    accountAssets: "Account Assets Dashboard",
    accountAssetsBoard: "Account Assets Dashboard",
    dataStatsCutoff: "Data as of:",
    accountBalance: "Account Balance",
    commonAccount: "General Account",
    agentAccount: "Master Franchisee Account",
    companyAccount: "Company Account",
    voucherAccount: "Referral Bonus Account",
    goldAccount: "Gold Account",
    cashAccount: "Cash Account",
    withdrawalAccount: "Withdrawal Account",
    bankTransfer: "Bank Transfer",
    hqCoBuildAccount: "Head Office Co-build Account",
    convertibleOptionAmount: "Convertible Option Amount",
    promotionAmount: "Marketing Fund",
    cityAmount: "City Development Fund",
    deliveryVoucherAccount: "Voucher Account",
    deliveryVoucherShort: "Voucher",
    deliveryAccountBalance: "Voucher Account Balance",
    issuedDeliveryVoucher: "Issued Vouchers",
    verifiedDeliveryVoucher: "Redeemed Vouchers",
    dualOrderPendingReturnVoucher: "Pending Voucher Returns (Duplicate Orders)",
    equipmentAssets: "Equipment Assets",
    equipmentType: "Equipment Type",
    cashAmount: "Cash Amount",
    voucherAmount: "Voucher Amount",
    totalAmount: "Total",
    freightAmount: "Shipping Fee",
    orderAssets: "Order Assets",
    purchaseOrder: "Purchase Orders",
    undeliveredPurchaseTotal: "Undelivered Purchase Orders (Total)",
    undeliveredPurchaseCash: "Undelivered Purchase Orders (Cash)",
    undeliveredPurchaseVoucher: "Undelivered Purchase Orders (Voucher)",
    creditOrderUndeliveredTotal: "Credit Orders (Undelivered, Paid Total)",
    creditOrderUndeliveredCash: "Credit Orders (Undelivered, Paid Cash)",
    creditOrderUndeliveredVoucher: "Credit Orders (Undelivered, Paid Voucher)",
    deliveryOrder: "Shipment Orders",
    shippedUnpaidTotal: "Shipped Orders (Unpaid Total)",
    shippedUnpaidCash: "Shipped Orders (Unpaid Cash)",
    shippedUnpaidVoucher: "Shipped Orders (Unpaid Voucher)",
    creditOrderShippedUnpaidTotal: "Credit Orders (Shipped, Unpaid Total)",
    creditOrderShippedUnpaidCash: "Credit Orders (Shipped, Unpaid Cash)",
    creditOrderShippedUnpaidVoucher: "Credit Orders (Shipped, Unpaid Voucher)",
    noDetailPermission: "You do not have permission to access this page.",
    expenseRecord: "Usage Records",
    rechargeRecord: "Recharge Records",
    recharge: "Recharge",
    withdraw: "Withdraw",
    transfer: "Transfer",
    inventoryValue: "Inventory Value",
    includeVoucher: "Including Voucher",
    pay: "Pay",
    remainingUnorderedAmount: "Remaining Unordered Amount",
    detail: "Details",
    totalPaymentAmount: "Total Delivery Payment Amount",
    paidPaymentAmount: "Paid Delivery Payment Amount",
    withdrawableAmount: "Withdrawable Amount",
    loanAmount: "Product Payment",
    notLoanAmount: "Non-Product Payment",
    nonPaymentRebateService: "Non-Product - Rebate and Service Fee",
    nonPaymentReferralCommission: "Non-Product - Referral Commission",
    nonPaymentOther: "Non-Product - Other",
    loanAmountLabel: "Product Payment Amount",
    notLoanAmountLabel: "Non-Product Payment Amount",
    nonPaymentRebateServiceLabel: "Non-Product Rebate and Service Fee Balance",
    nonPaymentReferralCommissionLabel: "Non-Product Referral Commission Balance",
    nonPaymentOtherLabel: "Non-Product Other Balance",
    inventoryValueTipA: "Total purchase price of unactivated full-price learning machines in inventory",
    inventoryValueTipB: "Parent-child machines and samples excluded",
    serialNo: "Transaction ID",
    rechargeAmount: "Recharge Amount",
    rechargeMethod: "Recharge Method",
    rechargeTime: "Recharge Time",
    operator: "Operator",
    remark: "Remark",
    accountType: "Account Type",
    account: "Account",
    rechargeSerial: "Recharge Serial",
    pleaseEnterRechargeSerial: "Enter recharge serial",
    pleaseSelectAccountType: "Select Account Type",
    pleaseSelectRechargeMethod: "Select Recharge Method",
    withdrawalSerial: "Withdrawal Serial",
    pleaseEnterWithdrawalSerial: "Enter withdrawal serial",
    withdrawalTime: "Withdrawal Time",
    withdrawalAmount: "Withdrawal Amount",
    paymentCategoryWithdrawAmount: "Loan Category Withdraw Amount",
    noPaymentCategoryWithdrawAmount: "Non-Loan Category Withdraw Amount",
    paymentCategoryTransferAmountTotal: "Loan Category Transfer Amount Total",
    noPaymentCategoryTransferAmountTotal: "Non-Loan Category Transfer Amount Total",
    rechargeType: "Recharge Type",
    pleaseSelectRechargeType: "Select Recharge Type",
    paymentCategoryType: "Product Payment",
    nonPaymentCategoryType: "Non-Product Payment",
    rechargeTypeAllAmount: "Mixed",
    applyStatus: "Application Status",
    pleaseSelectApplyStatus: "Select Application Status",
    withdrawStatusPendingSubmit: "Pending Submission",
    withdrawStatusPendingReview: "Pending Review",
    withdrawStatusPendingPay: "Pending Payment",
    transferAmount: "Transfer Amount",
    transferTime: "Transfer Time",
    cashAccountTransferTime: "Transfer Time",
    transferAccountType: "Transfer Account Type",
    payeeName: "Payee Name",
    depositBank: "Receiving Bank",
    payeeReceivingBank: "Receiving Bank",
    payeeAccount: "Payee Account",
    paymentUser: "Payer",
    pleaseSelectProject: "Select project",
    pleaseEnterSettlementNo: "Enter Settlement ID",
    settlementAmount: "Settlement Amount",
    receivedAmount: "Amount Paid",
    paymentTime: "Payment Time",
    pleaseSelectExpenditureMethod: "Select Payment Method",
    queryListFail: "Failed to load list",
    orderNo: "Purchase Order ID",
    buyNum: "Purchase Quantity",
    orderAmount: "Purchase Amount",
    payAmount: "Payment Amount",
    currency: "Currency",
    payMethod: "Payment Method",
    collectWaterPayMethod: {
      ...SHARED_PAY_METHOD_LABELS,
      bank_pay_confirm: "Bank Transfer Confirmation",
      withdrawal_account: "Withdrawal Account",
      cooperate_account: "Head Office Co-build Account",
      return_first_order: "First Order Payment Return",
      subscription_fee_rebate: "Subscription Fee Rebate",
      commodity_added_service_fee: "Value-Added Service Fee",
      squirrel_cup_award_amount: "Squirrel Cup Reward Amount",
      rewards_persuaders_debt_repurchase: "Debt Repurchase Persuader Reward",
      focus_fund: "Diversified Fund",
      renewal_payment_return: "Renewal Payment Return",
      delivery_account: "Delivery Voucher Account",
      delivery_voucher: "Delivery Voucher",
      collection_interest_margin: "Payment Interest Margin Distribution",
      organ_customer_upgrade_difference: "Institutional Customer Upgrade Price Difference",
      tmall_proxy_operation_pre_recharge: "Tmall Proxy Operation Prepayment",
      cloud_wechat_code: "Alipay",
      cloud_alipay_code: "WeChat Pay",
      channel_merchant_settlement: "Channel Franchisee Settlement",
      reward_options: "Reward Options",
      channel_options: "Channel Options",
      lecturer_options: "Lecturer Options",
      diversified_fund_options: "Diversified Fund Options",
      other_options: "Other Options",
      delivery_voucher_cash: "Delivery Voucher – Cash",
      delivery_voucher_reward: "Delivery Voucher – Reward",
      deduction_recharge: "Deduction Recharge",
      delivery_voucher_gold: "Delivery Voucher – Gold Account",
      angli_sub_card_profit_sharing: "Only Subscription Card Profit Sharing",
      cloud_substitute_alipay_code: "Squirrel Cloud Alipay",
      cloud_substitute_wechat_code: "Squirrel Cloud WeChat Pay",
      reimbursement: "Customer Visit Reimbursement",
      investment_meeting_prototype_policy: "Investment Event Demo Device Policy",
      beginner_account_return: "Starter Account Return",
      channel_agent_first_reward:
        "Channel Master Franchisee – First Order Reward",
      channel_agent_rebate_reward:
        "Channel Master Franchisee – Rebate Reward",
      channel_agent_service_fee_reward:
        "Channel Master Franchisee – Service Fee Reward",
      market_promotion_fee_refund: "Marketing Promotion Fee Refund",
      transfer_customer_payment_withdrawal: "Referral Customer Payment Withdrawal",
      reimbursement_for_recycling_equipment: "Reimbursement for Recycled Equipment",
      supplementary_express_delivery_fee: "Supplementary Shipping Fee",
      first_payment_reward_for_partners: "Partner First Payment Reward",
      partner_renewal_reward: "Partner Renewal Reward",
      shaping_account_promote: "Co-Build Account – Promotion Fee",
      transfer_gold_acct_to_options: "Gold Account to Options",
      transfer_cash_acct_to_options: "Cash Account to Options",
      transfer_fission_gold_acct_to_options: "Fission Gold Account to Options",
      transfer_withdrawal_acct_to_options: "Withdrawal Account to Options",
      transfer_cobranded_mktg_fund_to_options: "Co-Branded Marketing Fund to Options",
      transfer_cobranded_city_fund_to_options: "Co-Branded City Expansion Fund to Options",
      transfer_voucher_to_options: "Delivery Voucher to Options",
      transfer_cloud_warehouse_assets_to_options: "Cloud Warehouse Assets to Options",
      transfer_offline_inventory_to_options: "Offline Inventory to Options",
    },
    payTime: "Payment Time",
    paymentFlowTime: "Payment Time",
    pleaseEnterOrderNo: "Enter Purchase Order ID",
    purchaseExport: "Export Purchase Orders",
    deliveryInfoExport: "Export Shipment Data",
    deliveryInfoImport: "Import Shipment Data",
    allocateManufacturer: "Assign Manufacturer",
    generateDeliveryOrder: "Create Shipment Order",
    splitDelivery: "Split Shipment",
    deliveryOrderNo: "Shipment Order ID",
    createTime: "Created Time",
    operation: "Actions",
    initialPayment: "Initial Payment",
    more: "More",
    performanceSplit: "Performance Allocation",
    delete: "Delete",
    discount: "Discount",
    drawInvoice: "Issue Invoice",
    printDeliveryOrder: "Print Shipment Order",
    returnGoods: "Return Goods",
    returnFreight: "Refund Shipping Fee",
    manufacturer: "Manufacturer",
    pleaseSelectManufacturer: "Select Manufacturer",
    cancel: "Cancel",
    confirm: "Confirm",
    deliveryOrderConfirm: "Confirm Shipment Order",
    productName: "Product Name",
    waitSendNum: "Pending Shipment Quantity",
    thisDeliveryNum: "Shipment Quantity",
    pleaseEnterDeliveryNum: "Enter Shipment Quantity",
    allocateManufacturerSuccess: "Manufacturer assigned successfully",
    allocateManufacturerFail: "Failed to assign manufacturer",
    generateDeliverySuccess: "Shipment order created successfully",
    generateDeliveryFail: "Failed to create shipment order",
    splitDeliverySuccess: "Shipment split successfully",
    splitDeliveryFail: "Failed to split shipment",
    pleaseSelectOrder: "Select Order",
    pleaseSelectDeliveryOrder: "Select Shipment Order",
    pleaseSelectPurchaseOrder: "Select Purchase Order",
    singleOrderSplitOnly: "Only one order can be split at a time",
    orderNotSupportSplit: "This order cannot be split",
    deliveryNumExceedWait: "Shipment quantity cannot exceed pending quantity",
    orderWithVoucherCannotCancel: "This order cannot be canceled because vouchers have already been issued",
    pleaseEnterPositiveInteger: "Enter a positive integer",
    exportDeliveryList: "Export Shipment Order List",
    goodsTransferRecord: "Inventory Transfer Records",
    export: "Export",
    snCode: "SN Code",
    pleaseEnterSnCode: "Enter SN Code",
    transferOutAgent: "Transfer Out (Master Franchisee)",
    transferInAgent: "Transfer In (Master Franchisee)",
    pleaseSelectAgent: "Select Master Franchisee",
    goodsTransferTime: "Transfer Time",
    productType: "Product Type",
    currentAvailableSampleIndex: "Available Sample Device Quota",
    sampleIndexQueryExportFileName: "Sample Device Quota Export",
    sampleIndexRuleInterpretation: "Sample Device Quota Rules & Guidelines",
    newGbChargerOwnCnt: "Quota From Purchased Learning Machines",
    newGbChargerUseCnt: "Used Quota",
    newGbChargerAvailableCnt: "Available Quota",
    newGbChargerIndexQueryExportFileName: "New Standard Charger Quota Export",
    expenseCalendarPayTime: "Payment Time",
    invoicePdf: "Invoice.pdf",
    equityInfo: "Benefits Information",
    verificationInfo: "Redemption Details",
    pleaseSelectProductType: "Select product type",
    deviceSnCode: "Device SN Code",
    transferOutAgentId: "Transfer Out Master Franchisee ID",
    transferOutAgentName: "Transfer Out Master Franchisee Name",
    transferOutOrderNo: "Transfer Out Order ID",
    transferInAgentId: "Transfer In Master Franchisee ID",
    transferInAgentName: "Transfer In Master Franchisee Name",
    transferInOrderNo: "Transfer In Order ID",
    transferPerson: "Transfer Operator",
    hqTransferRecordExport: "HQ Transfer Record Export",
    applicationRecord: "Trial Account Application Records",
    applicationDate: "Application Date",
    applicationPhone: "Application Phone Number",
    pleaseEnterPhone: "Enter Phone Number",
    applicationTime: "Application Time",
    experienceAccount: "Trial Account",
    experienceAccountPassword: "Trial Account Password",
    accountValidDate: "Account Valid Until",
    queryFail: "Failed to load data",
    operationSuccess: "Operation successful",
    operationFail: "Operation failed",
    submitSuccess: "Submitted successfully",
    submitFail: "Submission failed",
    cancelSuccess: "Cancelled successfully",
    cancelFail: "Cancellation failed",
    confirmSuccess: "Confirmed successfully",
    confirmFail: "Confirmation failed",
    saveSuccess: "Saved successfully",
    saveFail: "Save failed",
    modifySuccess: "Updated successfully",
    deleteSuccess: "Deleted successfully",
    withdrawSuccess: "Withdrawal successful",
    pleaseEnterReimburseAmount: "Enter Reimbursement Amount",
    pleaseSelectExpressCompany: "Please select express company",
    pleaseEnterExpressNo: "Please enter express tracking number",
    pleaseEnterExpressPhone: "Please enter express phone number",
    onlyUploadPdfPngJpg: "Only PDF, PNG, JPG, and JPEG files are allowed",
    maxUpload20M: "Maximum file size: 20MB",
    onlyUploadPngJpgPdf: "Only png, jpg, jpeg, pdf files allowed",
    maxUpload5M: "Maximum file size: 5MB",
    pleaseEnter11DigitPhone: "Enter an 11-digit phone number",
    pleaseUploadAttachmentFirst: "Please upload attachment first",
    pleaseSelectVisitRecordFirst: "Please select visit record first",
    pleaseCompleteReimburseForm: "Please complete reimbursement form first",
    noWithdrawData: "No withdrawal data available",
    pleaseEnterPayeeName: "Enter Payee Name",
    pleaseEnterBankName: "Enter Bank Name",
    pleaseEnterPayeeAccount: "Enter Payee Account",
    pleaseEnterContactPhone: "Enter Contact Phone Number",
    noInvoiceUploadTip: "Please upload invoice before submitting for HQ finance review.",
    operationFailRetry: "Operation failed, please retry",
    getDataFail: "Failed to get data",
    deleteFail: "Delete failed",
    operationSuccessExclamation: "Operation Successful!",
    operationFailExclamation: "Operation Failed!",
    pleaseEnterInvoiceType: "Enter Invoice Type",
    operationNotAllowed: "Operation not allowed",
    invoiceSuccess: "Invoice issued successfully",
    invoiceFail: "Failed to issue invoice",
    noValidUploadData: "No valid data to upload",
    pleaseEnterPurchaseNo: "Please enter purchase order no",
    onlyXlsxXlsFormat: "Only .xlsx and .xls files are supported",
    pleaseSelectFileFirst: "Please select file first",
    importSuccess: "Import successful",
    importFail: "Import failed",
    onlyImageFormat: "Only JPG, JPEG, GIF, PNG, BMP images allowed",
    exceed5MLimit: "File size exceeds 5MB limit",
    maxOneImage: "Maximum 1 image allowed",
    applyOrderNo: "Application ID",
    applyWithdrawAmount: "Requested Withdrawal Amount",
    pleaseEnterWithdrawAmount: "Enter Withdrawal Amount",
    bankInfoPlaceholder: "Include province, city, head office and branch info",
    bankExample: "e.g. ICBC Jiangsu Nanjing Fujian Road Branch",
    contactPhone: "Contact Phone Number",
    auditRemark: "Review Comments",
    invoiceUpload: "Invoice Upload:",
    maxUpload5Pdf: "Upload up to 5 PDF files",
    noInvoiceData: "No invoice info",
    invoiceUploadTip: "Please upload red-stamp invoice first. If not available, upload screenshot of uninvoiced orders. Finance will deduct corresponding order invoice amount based on withdrawal amount.",
    invoiceInfo: "Invoice Information:",
    invoiceUnit: "Billing Entity",
    invoiceItem: "Invoice Item",
    invoiceAmount: "Invoice Amount",
    invoiceN: "Invoice {n}:",
    withdrawApplyDetail: "Withdrawal Application Details",
    withdrawApplySubmitInvoice: "Submit Invoice for Withdrawal",
    withdrawApplyModify: "Edit Withdrawal Application",
    agent: "Master Franchisee",
    agentId: "Agent ID",
    agentName: "Agent Name",
    applyType: "Application Type",
    applyTypeAll: "All",
    applyTypeWithdraw: "Withdrawal application",
    applyTypeCashTransfer: "Transfer to cash application",
    applyAmount: "Application Amount",
    bankAccount: "Bank Account",
    applyTime: "Apply Time",
    submitTime: "Submission Time",
    applicant: "Applicant",
    auditor: "Reviewer",
    pleaseEnterApplyOrderNo: "Enter Application ID",
    submitInvoice: "Submit Invoice",
    confirmCancel: "Confirm to cancel?",
    cashAccountDetail: "Cash Account Transfer Details",
    cashAccountSubmitInvoice: "Cash Account Submit Invoice",
    cashAccountModify: "Cash Account Modify",
    pleaseEnterApplyAmount: "Enter apply amount",
    pleaseEnterTransferAmount: "Enter transfer amount",
    withdrawAccountInsufficient: "Insufficient withdrawal account balance!",
    noInvoiceConfirmSubmit: "No invoice uploaded. Confirm to submit for HQ finance review?",
    pleaseEnterContact: "Enter contact info",
    refundRecordListExport: "Export Refund Records",
    refundRecordOrderNo: "Order ID",
    refundInfo: "Refund Information",
    refundSignMain: "Contract Entity",
    refundOrgIdName: "Organization ID / Name",
    refundHandStatus: "Handover Status",
    refundStatusLabel: "Refund Status",
    refundTotalAmount: "Total Refund Amount",
    refundTotalAmountPlaceholder: "Enter total refund amount",
    deductAmount: "Deduct Amount",
    deductAmountPlaceholder: "Enter deduct amount",
    convertOption: "Convertible Option",
    convertOptionPlaceholder: "Enter convert option",
    exchangeClassFee: "Exchange Class Fee",
    exchangeAmountPlaceholder: "Enter exchange amount",
    actualRefundAmount: "Actual Refund Amount",
    actualRefundAmountPlaceholder: "Enter actual refund amount",
    terminationAgreementEndTime: "Termination Agreement End Time",
    terminationAgreementEntryTime: "Termination Agreement Entry Time",
    refundMethod: "Refund Method",
    refundMethodPlaceholder: "Enter refund method",
    refundReasonLabel: "Refund Reason",
    refundReasonPlaceholder: "Enter refund reason",
    firstRefundTimeLabel: "First Payment Time",
    firstRefundAmountLabel: "First Payment Amount",
    secondRefundTimeLabel: "Second Payment Time",
    secondRefundAmountLabel: "Second Payment Amount",
    lastRefundTimeLabel: "Last Payment Time",
    lastRefundAmountLabel: "Last Payment Amount",
    otherLoanTimeLabel: "Other Payment Time",
    otherLoanAmountLabel: "Other Payment Amount",
    otherLoanAmountPlaceholder: "Enter other payment amount",
    otherLoanRemarkLabel: "Other Payment Remark",
    otherLoanRemarkPlaceholder: "Enter remark",
    refundCycleLabel: "Payment Installment",
    refundCyclePlaceholder: "Enter installment",
    terminationAttachmentLabel: "Attachment (Termination Agreement):",
    uploadFileButton: "Upload File",
    refundPaymentInfo: "Refund Payment Details",
    attachment: "Attachment",
    addRefundPaymentInfoTitle: "Add Refund Payment Details",
    refundAmountLabel: "Refund Amount",
    refundAmountPlaceholder: "Enter refund amount",
    refundAccountLabel: "Refund Account",
    refundAccountPlaceholder: "Enter refund account",
    refundTimeLabel: "Payment Time",
    uploadAttachmentButton: "Upload Attachment",
    cancelRefund: "Cancel Refund",
    cancelRefundConfirmPrefix: 'Are you sure you want to cancel the refund for “',
    cancelRefundConfirmSuffix: '”?',
    maxUpload50M: "Maximum File Size: 50 MB",
    uploadSuccessWithName: "{name} Uploaded Successfully",
    uploadFailWithName: "{name} Upload Failed",
    productModel: "Product Model",
    unitPrice: "Unit Price",
    pleaseFillAmount: "Enter Amount",
    pleaseFillPayMethod: "Enter Payment Method",
    pleaseSelectPayTime: "Select Payment Time",
    pleaseSelectRechargeTime: "Select recharge time",
    pleaseSelectFlowStatus: "Select Transaction Status",
    paySerial: "Payment Reference",
    pleaseFillPaySerial: "Enter Payment Reference",
    pleaseUploadImage: "Please upload image",
    fillError: "Input Error",
    fail: "Failed",
    totalLabel: "Total: ",
    sendEmail: "Send Email",
    deviceAmount: "Device Amount",
    softwareAmount: "Software Amount",
    recalcAmount: "Recalculate Amount",
    save: "Save",
    pleaseEnterEmail: "Please enter email",
    invalidEmailFormat: "Invalid Email Format",
    pleaseEnterDeviceAmount: "Please enter device amount",
    formatErrorNumber: "Invalid Format, Enter a Number",
    amountCannotBeNegative: "Amount Cannot Be Negative",
    pleaseEnterSoftwareAmount: "Please enter software amount",
    pleaseSelectInvoiceType: "Select Invoice Type",
    invoiceHeaderType: "Invoice Header Type:",
    company: "Company",
    personal: "Personal",
    companyHead: "Company Name:",
    pleaseFillCompanyHead: "Enter company name",
    dutyParagraph: "Tax ID:",
    pleaseFillDutyParagraph: "Enter tax ID",
    phone: "Phone Number:",
    pleaseFillPhone: "Enter phone",
    address: "Address:",
    pleaseFillAddress: "Enter address",
    pleaseFillBank: "Enter bank name",
    bankAccountColon: "Bank Account:",
    pleaseFillBankAccount: "Enter bank account",
    invoiceTypeColon: "Invoice Type:",
    pleaseSelectInvoiceTypeColon: "Select invoice type",
    email: "Email Address:",
    pleaseFillEmail: "Enter email",
    businessLicense: "Business License:",
    clickUploadImage: "Upload Image",
    legalIdFront: "Authorized Representative ID (Front):",
    legalIdBack: "Authorized Representative ID (Back):",
    agentNameColon: "Name:",
    pleaseFillName: "Enter name",
    idCard: "ID Number:",
    pleaseFillIdCard: "Enter ID card no.",
    idCardFront: "ID (Front):",
    idCardBack: "ID (Back):",
    previewFile: "Preview File",
    deleteFile: "Delete File",
    emailRequired: "Email is required",
    pleaseEnterValidEmail: "Enter a Valid Email Address",
    pleaseUploadBusinessLicense: "Upload business license",
    pleaseUploadLegalIdFront: "Upload legal rep ID front",
    pleaseUploadLegalIdBack: "Upload legal rep ID back",
    pleaseUploadIdCardFront: "Upload ID card front",
    pleaseUploadIdCardBack: "Upload ID card back",
    onlyImageFormatJpg: "Supported Formats: JPG, JPEG, GIF, PNG, BMP",
    exceed5MLimitUpload: "File Size Exceeds 5 MB Limit",
    applyWithdraw: "Apply for Withdrawal",
    cashAccountTransfer: "Transfer to Cash Account",
    autoCalcMaxWithdrawTip: "Maximum Withdrawable Amount Is Calculated Automatically Based on Selected Recharge Type",
    saveAutoGenerate: "Auto-generated on save, cannot be modified",
    maxWithdrawableAmount: "Max Withdrawable Amount",
    maxApplyAmount: "Max Apply Amount",
    contactAutoFromInvoice: "Auto from invoice header, editable",
    close: "Close",
    nonPaymentInvoiceTip: "Non-payment Invoice Reminder",
    invoiceSubmitTip: "After Issuing the Invoice, Submit It via \"Finance Center → Master Franchisee Account → Cash Account Transfer\"",
    gotIt: "Got it",
    paymentInvoiceTip: "Payment Invoice Reminder",
    businessLicenseShort: "Business License",
    idCardFrontShort: "ID Card Front",
    idCardBackShort: "ID Card Back",
    invoiceConfirmTip: "Once invoice info is confirmed, it cannot be changed. Confirm?",
    cancelConfirm: "Cancel Confirm",
    cancelConfirmTip: "Cancel confirmation?",
    rechargeNow: "Recharge Now",
    note: "Note:",
    deductStorageFee: "Deduct Warehouse Management Fee",
    deductStorageFeeConfirm: "Deduct storage management fee from distributor delivery voucher account?",
    deductStorageFeeCannotTip: "Deducted or unconfirmed records cannot be deducted. Please reselect.",
    reimburseApply: "Reimbursement Application",
    expressNo: "Tracking Number",
    view: "View",
    visitRecord: "Visit Record",
    confirmCancelReimburse: "Are You Sure You Want to Cancel This Reimbursement?",
    viewAttachment: "View Attachment",
    confirmDeleteRecord: "This Action Will Permanently Delete the Record. Continue?",
    visitCustomerName: "Visit Customer Name",
    visitCustomerPhone: "Customer Phone Number",
    visitCampusId: "Franchisee ID",
    visitCampusName: "Franchisee Name",
    storeId: "Store ID",
    visitStoreAddress: "Visit Store Address",
    deliveryDate: "Delivery Date",
    pleaseSelectSubscriptionAgent: "Select subscription card agent",
    purchaseQty: "Purchase Qty",
    invoiceConfirm: "Invoice Confirm",
    regionAgentName: "Regional Master Franchisee Name",
    regionAgentId: "Regional Master Franchisee ID",
    returnAmount: "Payment Amount",
    currentBalance: "Current Balance",
    confirmAmountLabel: "Confirmed Amount",
    confirmTime: "Confirmation Time",
    signTime: "Check-in Time",
    auditTime: "Audit Time",
    to: "To",
    reimburseNo: "Reimbursement ID",
    pleaseEnterNo: "Enter no",
    createBy: "Creator",
    creator: "Creator",
    reimburseTotalAmount: "Total Reimbursement Amount",
    expressCompany: "Express Company",
    expressPhone: "Courier Phone Number",
    invoiceMailAddress: "Invoice Mail Address",
    recipientInfo: "Recipient Information",
    reimburseInvoiceUpload: "Upload Reimbursement Invoice",
    pleaseSelectVisitRecord: "Select visit record",
    selectVisitRecord: "Select Visit Record",
    confirmDelete: "Confirm Deletion?",
    reimburseTip: "Please mail the paper invoice to the above address and fill in the correct express number for timely processing.",
    uploadPdfOrImage: "Upload PDF or image",
    invoiceAddressExample: "Building E, 5F, 1080 Lianhua Road, Minhang District, Shanghai",
    recipientInfoExample: "Shen Mengyu 18918671328",
    statementConfirm: "Statement Confirmation",
    confirmResult: "Confirmation Result:",
    noWithdraw: "Do Not Withdraw",
    payeeNameConsistent: "Must Match the Master Franchisee Name",
    bankExampleShort: "e.g. ICBC Jiangsu Nanjing Fujian Road Branch",
    confirmInvoiceAmountTotal: "Confirmed Invoice Amount:",
    unconfirmInvoiceAmountTotal: "Unconfirmed Invoice Amount:",
    statementConfirmTip1: "1. Once confirmed, withdraw will deduct from cash account immediately and cannot be changed;",
    statementConfirmTip2: "After confirmation, payments will be processed offline by finance to each regional Master Franchisee.",
    statementConfirmTip3: "3. If withdrawing, please fill in payee account info accurately;",
    statementConfirmTip4: "4. If no withdraw, balance stays in account for order payment;",
    statementConfirmTip5: "5. Only confirmed invoice order refunds can be withdrawn;",
    audit: "Audit",
    return: "Return",
    pleaseEnterReturnNo: "Enter Return Order ID",
    returnOrder: "Return Order",
    subscriptionCashReturnAmount: "Subscription Card Cash Return Amount",
    payVoucher: "Pay Voucher",
    auditPass: "Approved",
    auditReject: "Rejected",
    auditResult: "Audit Result",
    invoiceAmountColon: "Invoice Amount:",
    cashAccountReturnInfo: "Cash Account Return Info",
    accountName: "Account Name",
    accountNo: "Account ID",
    returnRecord: "Return Record",
    subscriptionVerifyDetail: "Subscription Card Verification Details",
    processTime: "Process Time",
    processBy: "Process By",
    processResult: "Process Result",
    verifySerialNo: "Verification Reference",
    subscriptionCardNo: "Subscription Card No.",
    subscriptionCardType: "Subscription Card Type",
    subscriptionAgentId: "Subscription Card Master Franchisee ID",
    subscriptionAgentName: "Subscription Card Master Franchisee Name",
    cashPayAmount: "Cash Pay Amount",
    voucherPayAmount: "Voucher Pay Amount",
    agentCashReturnAmount: "Master Franchisee Cash Return Amount",
    agentVoucherReturnAmount: "Master Franchisee Voucher Return Amount",
    refundAmount: "Refund Amount",
    refundAccount: "Refund Account",
    refundTime: "Refund Time",
    refundType: "Refund Type",
    refundBy: "Refunded By",
    totalFlowCount: 'Total {n} Transactions, Total Payment Amount ${m}',
    payAmountTotal: 'Total Payment Amount ${m}',
    applyStatusLabel: "Status",
    pleaseSelectStatus: "Select Status",
    cashReturnAmount: "Cash Return Amount",
    fissionReturnAmount: "Voucher Return Amount",
    lastEditTime: "Last Edited Time",
    lastProcessor: "Last Processed By",
    expenditureMethod: "Payment Method",
    payTypeLabel: "Payment Type",
    paymentFlowDataType: {
      purchase_order: "Purchase payment",
      private_order: "Regional payment",
      withdrawal_order: "Withdrawal payment",
      store_order: "Warehouse management fee payment",
      settlement_order: "Settlement payment",
      gold_order: "Gold coin payment",
    },
    accountChangeType: "Account Activity Type",
    accountRecharge: "Account Recharge",
    accountExpense: "Account Expense",
    accountTransfer: "Account Transfer",
    unread: "Unread",
    read: "Read",
    sendTime: "Sent Time",
    noticeContent: "Notification Content",
    accountChangeNotice: "Account Change Notice",
    readAction: "Read",
    readSuccess: "Marked as Read",
    settlementNo: "Settlement ID",
    settlementType: "Settlement Type",
    settlementStatus: "Settlement Status",
    pleaseSelectSettlementType: "Select Settlement Type",
    pleaseSelectSettlementStatus: "Select Settlement Status",
    expenditureTransferMethod: "Expense / Transfer Method",
    pleaseSelectItem: "Select item",
    pleaseSelectTransferInAgent: "Select Receiving Master Franchisee",
    transferInAccountType: "Receiving Account Type",
    pleaseSelectTransferInAccountType: "Select Receiving Account Type",
    transferInItem: "Receiving Item",
    lastPayTimeLabel: "Last Pay Time",
    pleaseEnterCreator: "Enter creator",
    accountChangeNotification: "Account Change Notification",
    pleaseSelectChangeType: "Select Change Type",
    pleaseSelectRefundType: "Select Refund Type",
    pleaseSelectRefundAccount: "Select Refund Account",
    pleaseEnterOrderNoShort: "Enter Order ID",
    batchConfirm: "Batch Confirm",
    batchBindOrder: "Batch Bind Orders",
    confirmRechargeToWithdraw: "The system will transfer the commission amount to the Master Franchisee withdrawal account. Are you sure you want to proceed?",
    serviceProviderStatus: "Service Provider Status",
    rechargeStatus: "Recharge Status",
    confirmed: "Confirmed",
    commissionMonth: "Commission Month",
    commissionRechargeType: "Commission Recharge Type",
    returnFirstOrderRebate: "First Order Payment Return",
    subscriptionFeeRebate: "Subscription Fee Commission",
    commodityAddedServiceFee: "Value-Added Service Fee",
    amount: "Amount",
    generateTime: "Generated Time",
    confirmBy: "Confirm By",
    pleaseSelectMonth: "Select Month",
    totalFlowRechargeAmount: "Total {n} Transactions, Total Recharge Amount ${m}",
    flowStatus: "Transaction Status",
    confirmRemark: "Confirmation Remark",
    financeConfirm: "Finance Confirmation",
    bindOrder: "Bind Order",
    paymentConfirm: "Payment Confirmation",
    rechargeAmountColon: "Recharge Amount:",
    rechargeTimeColon: "Recharge Time:",
    rechargeSerialColon: "Recharge Reference:",
    flowStatusColon: "Transaction Status:",
    rechargeVoucher: "Recharge Voucher",
    rechargeVoucherColon: "Recharge Voucher:",
    returnBack: "Return Back",
    invalid: "Invalid",
    reissue: "Reissue",
    confirmInvalidInvoice: "Are you sure you want to void this invoice? Once voided, it cannot be restored.",
    isInvalid: "Is Invalid",
    yes: "Yes",
    no: "No",
    pleaseSelectInvalid: "Select invalid status",
    invoiceNo: "Invoice Number",
    controlInvoicesOrderNo: "Order ID",
    pleaseEnterInvoiceNo: "Enter Invoice Number",
    imageLoadFail: "Image Failed to Load",
    invalidSuccess: "Voided Successfully",
    invalidFail: "Void Failed",
    annexPreview: "Attachment Preview",
    batchBindSuccess: "Batch Binding Successful",
    batchBindFail: "Batch Binding Failed",
    remarkColon: "Remark:",
    confirmRemarkColon: "Confirmation Remark:",
    indexNo: "No.",
    projectName: "Project Name",
    specModel: "Specification / Model",
    itemCount: "Quantity",
    taxAmount: "Tax Amount",
    invoiceDate: "Invoice Date",
    rechargeIdLabel: "Recharge ID",
    pleaseEnterRechargeId: "Enter Recharge ID",
    payMethodLabel: "Recharge Method",
    itemType: "Item",
    transferAmountLabel: "Transfer Amount",
    pendingConfirm: "Pending Confirmation",
    pleaseSelectConfirmBy: "Select Confirmed By",
    pleaseEnterPhoneShort: "Enter Phone Number",
    nameLabel: "Name",
    searchByNamePlaceholder: "Search by Name or Company Name",
    headType: "Header Type",
    pleaseSelectHeadType: "Select Header Type",
    companyHeadOrName: "Company Name / Individual Name",
    dutyParagraphShort: "Tax No",
    idCardShort: "ID Number",
    invoiceAssortName: "Invoice Type",
    addressShort: "Address",
    bankShort: "Bank Name",
    bankAccountShort: "Bank Account",
    cycleExpiryTime: "Cycle Expiration Time",
    exemptionExpiryNo: "Exemption Expiration ID",
    pleaseEnterNoShort: "Enter ID",
    agentTypeShort: "Master Franchisee Type",
    pleaseSelectType: "Select type",
    currentCycle: "Current Cycle",
    initialBalance: "Beginning Balance",
    currentPeriodReceiveAmount: "Current Period Received Voucher Amount",
    currentPeriodConsumeAmount: "Current Period Consumed Voucher Amount",
    exemptionNonOrderAmount: "Expired Unused Voucher Amount",
    exemptionNonOrderNum: "Expired Unused Device Quantity",
    estimatedCost: "Estimated Cost",
    actualCost: "Actual Cost",
    deductTime: "Deduct Time",
    deductBy: "Deducted By",
    obtainRecord: "Obtain Record",
    transferRecord: "Transfer Record",
    myIssuedVoucher: "Issued Vouchers",
    myVerifiedVoucher: "Verified Vouchers",
    myReceivedVoucher: "Received Vouchers",
    myConsumedVoucher: "Consumed Vouchers",
    equityDesc: "Benefit Description",
    equityDescTitle: "Benefit Description - {name}",
    rightType: "Benefit Type",
    pleaseSelectRightType: "Select Benefit Type",
    rightName: "Benefit Name",
    pleaseEnterRightName: "Enter Benefit Name",
    rightCode: "Benefit Code",
    pleaseEnterRightCode: "Enter Benefit Code",
    grantTime: "Granted Time",
    obtainTime: "Obtained Time",
    verifyTime: "Verification Time",
    recordNo: "Reference Number",
    pleaseEnterRecordNo: "Enter Reference Number",
    purchaseNoCol: "Purchase Order ID",
    purchaseOrderNo: "Purchase Order",
    pleaseEnterPurchaseOrder: "Enter purchase order",
    consumeCampusId: "Associated Master Franchisee ID",
    consumeCampusName: "Associated Master Franchisee Name",
    consumeVoucherAmount: "Consumed Voucher Amount",
    grantCampusId: "Issuing Master Franchisee ID",
    grantCampusName: "Issuing Master Franchisee Name",
    relatedCampusId: "Related Master Franchisee ID",
    relatedCampusName: "Related Master Franchisee Name",
    consumeBy: "Consume By",
    grantRemark: "Issuance Remark",
    consumeRemark: "Consume Remark",
    grantBy: "Issued By",
    receiveCampusId: "Associated Master Franchisee ID",
    receiveCampusName: "Associated Master Franchisee Name",
    expirationTime: "Expiration Time",
    verifyCampusId: "Verifying Master Franchisee ID",
    verifyCampusName: "Verifying Master Franchisee Name",
    verifyAmount: "Verified Amount",
    verifyOrder: "Verification Order",
    verifyBy: "Verified By",
    rightForm: "Benefit Form",
    pleaseSelectRightForm: "Select Benefit Form",
    validDeadline: "Expiration Date",
    distributeBy: "Distributed By",
    validityPeriod: "Validity Period",
    belongDealer: "Associated Franchisee",
    consNo: "Verification ID",
    consTime: "Verification Time",
    consType: "Verification Method",
    consRemark: "Remark",
    rightLevel: "Benefit Level",
    rightAmount: "Benefit Amount",
    applicableModel: "Applicable Product Model",
    rightDiscount: "Benefit Discount",
    marketingActivity: "Marketing Campaign",
    activityPrice: "Promotional Price",
    rightQuantity: "Benefit Quantity",
    exclusiveAttr: "Exclusive Attribute",
    withdrawRecord: "Withdrawal Record",
    cashTransferRecord: "Cash Account Transfer Record",
    newDoubleOrder: "Create Double Order",
    agentNotActivatedTip: "This Master Franchisee account has not been activated. Do you want to proceed with creating a double order?",
    withdrawableAmountColon: "Withdrawable Amount:",
    goldAccountBalance: "Gold Account Balance",
    transferNo: "Reference Number",
    transferNum: "Transfer Quantity",
    goldCoinTransferTime: "Transfer Time",
    transferOutAccount: "Transfer-out Account",
    transferInAccount: "Transfer-in Account",
    pleaseSelectAccount: "Select account",
    pleaseSelectReceiveAccount: "Select Receiving Account",
    consumeNo: "Reference Number",
    consumeNum: "Consumed Quantity",
    consumeTime: "Consumption Time",
    consumeAccount: "Consumption Account",
    studentName: "Student Name",
    studentAccount: "Student Account",
    pleaseEnterStudentName: "Enter Student Name",
    obtainNo: "Reference Number",
    obtainNum: "Acquired Quantity",
    obtainMethod: "Acquisition Method",
    pleaseSelectObtainMethod: "Select Acquisition Method",
    obtainTimeLabel: "Acquisition Time",
    obtainUser: "Acquired By",
    cashAccountBalance: "Cash Account Balance",
    deliveryVoucherBalance: "Voucher Balance",
    subAgentLabel: "Subordinate Master Franchisee",
    createFail: "Creation Failed",
    nonCompanyWithdrawTip: "Your agent entity is not a company. Please go to Finance Center -> Invoice -> Invoice Header to apply as company type. After approval, you can apply for withdrawal.",
    applySuccess: "Application Successful",
    /** Withdrawal success toast (non-loan branch, en-US locale, etc.) */
    saveSuccessAwaitFinanceReview:
      "Saved successfully. Waiting for finance review and disbursement.",
    applyFail: "Application Failed",
    loanTransferAutoConfirmTip: "Loan transfer to cash account requires no invoice. Auto-confirmed and amount transferred.",
    transferSuccessTip: "Submitted successfully. Amount transferred to cash account.",
    exemptionExpiringAmount: "Voucher Amount Near Expiration",
    estimatedStorageFee: "Estimated Warehouse Management Fee",
    agentGoldAccount: "Master Franchisee Gold Account",
    staffGoldAccount: "Staff Gold Account",
    goToPurchase: "Go to Purchase",
    jumpToMiniProgram: "Open App",
    snCodeUpdate: "SN Code Update",
    oldSNCode: "Old SN Code:",
    newSNCode: "New SN Code:",
    pleaseEnterOldSNCode: "Enter Old SN Code",
    pleaseEnterNewSNCode: "Enter New SN Code",
    addServiceCenter: "Add Service Center",
    serviceAddress: "Service Center Address:",
    pleaseEnterAgentId: "Enter Master Franchisee ID",
    pleaseEnterServiceAddress: "Enter Service Center Address",
    agentOrderStatusUpdate: "Master Franchisee Order Status Update",
    purchaseNo: "Purchase Order ID:",
    purchaseType: "Purchase Type:",
    orderStatus: "Order Status:",
    dispatchType: "Delivery Method:",
    pleaseEnterPurchaseNoShort: "Enter Purchase Order ID",
    pleaseSelectPurchaseType: "Select Purchase Type",
    pleaseSelectOrderStatus: "Select Order Status",
    pleaseSelectDispatchType: "Select Delivery Method",
    pleaseEnterRegionAgentId: "Enter Regional Master Franchisee ID",
    agentWarehouse: "Master Franchisee Warehouse:",
    pleaseSelectAgentWarehouse: "Select Master Franchisee Warehouse",
    applicationType: "Application Type",
    transferIn: "Transfer In",
    transferOut: "Transfer Out",
    transferType: "Transfer Type",
    batchTransferIn: "Batch Transfer In",
    transferOutAgentLabel: "Sending Master Franchisee",
    agentLabel: "Master Franchisee",
    payAmountLabel: "Payment Amount",
    transferOutAmount: "Transfer Out Amount",
    selectFileAndImport: "Select a File to Import",
    dragOrClick: "Drag File Here or",
    clickUpload: "Click to Upload",
    attachments: "Attachments",
    pleaseEnterRemark200: "Enter Remark (Max 200 Characters)",
    balance: "Balance",
    time: "Time",
    status: "Status",
    yuan: "$",
    errorOccurred: "An Error Occurred",
    statusPendingSubmit: "Pending Submission",
    statusPendingAudit: "Pending Review",
    statusReturned: "Returned",
    statusCancelled: "Cancelled",
    statusPendingPayment: "Pending Payment",
    statusCompleted: "Completed",
    pleaseSelectInitialAccount: "Select Initial Account",
    pleaseEnterInitialAmount: "Enter Initial Amount",
    pleaseSelectPayMethod: "Select Payment Method",
    pleaseEnterPaySerialNo: "Enter Payment Reference",
    pleaseSelect: "Select Status",
    jiedanhao: "Settlement ID",
    mu: "Item",
    chu: "Expense Method",
    caozuo: "Operator",
    pleaseEnter: "Enter return order no.",
    hao: "ID Card No.",
    valuation: "Valuation",
    order: "Purchase Order",
    student: "Student",
    chuzhanghu: "Transfer Out Account",
    ruzhanghu: "Transfer In Account",
    dianhua: "Phone Number",
    dian: "Email Address",
    individual: "Individual",
    pending: "Pending Confirmation",
    already: "Confirmed",
    not: "Unconfirmed",
    danhao: "Return Order ID",
    xinli: "Last Processed By",
    textfhuc: "Name",
    text1k65: "City / District",
    text6n7l: "John Doe",
    textqeco: "Los Angeles",
    textiq60: "123 Main Street, Los Angeles, CA 90001",
    textt7uv: "Province",
    text7633: "ZIP Code",
    texteb5j: "Putuo District",
    text5owf: "Available Sample Quota",
    textmv1l: "Sample Quota from Purchase",
    textv66y: "Sample Quota from Promotion",
    textg5ii: "Used Sample Quota",
    withdrawStatusReturned: "Returned",
    withdrawStatusCompleted: "Completed",
    date: "Date",
    invoiceType: "Invoice Type",
    quantity: "Quantity",
    taxRatio: "Tax Rate",
    type: "Commission Recharge Type",
    xiaozhanghu: "Consumption Account",
    name: "Master Franchisee Name",
    zhanghu: "Bank Account",
    qu: "Obtain Method",
    kaihu: "Bank Name",
    month: "Commission Month",
    queren: "Confirmed By",
    qing: "Applicant",
    textzuxc: "Name",
    textkxzs: "City / District",
    text2gks: "Product Name",
    equityDescLabel: "Equity Description:",
    equityUsageLabel: "How to Use:",
    // Monthly Bill - List
    monthlyBill: "Monthly Bill",
    monthlyBillYear: "Year",
    pleaseSelectYear: "Select Year",
    monthlyBillMonth: "Bill Month",
    monthlyBillNo: "Bill No.",
    fixedRoyaltyFee: "Fixed Royalty",
    registrationFee: "Registration Fee",
    supervisionFee: "Supervision Fee",
    marketingFeeLabel: "Marketing Fee",
    subtotal: "Subtotal",
    monthlyBillTotal: "Bill Total",
    monthlyBillStatus: "Status",
    paymentDeadline: "Payment Deadline",
    monthlyBillViewDetail: "View Details",
    monthlyBillPay: "Pay",
    monthlyBillBillOf: "Bill of {month}",
    cumulativePayment: "Cumulative Payment",
    annualTotal: "Fiscal Year {year}",
    totalNPeriods: "{n} period(s) in {year}",
    generatedOn: "Auto-generated on {date}",
    billHistoryTitle: "Bill History",

    // Equipment to Option
    equipmentToOption: {
      pageTitle: 'Inventory Equipment to Option',
      modelLabel: 'Model',
      allModels: 'All Models',
      warehouseLabel: 'Warehouse',
      allWarehouses: 'All Warehouses',
      applyStatusLabel: 'Apply Status',
      allStatus: 'All',
      pleaseSelect: 'Please Select',
      searchButton: 'Search',
      resetButton: 'Reset',
      totalDevices: 'Total {count} devices',
      exportButton: 'Export',
      submitApplyButton: 'Submit Option Application',
      confirmDialogTitle: 'Confirm Option Application',
      confirmDialogDesc: 'Please confirm the application details. After submission, devices will be locked pending HQ review.',
      deviceCount: 'Device Count',
      totalAmount: 'Total Option Amount',
      applicant: 'Applicant',
      warningTip: 'Devices will be locked after submission and cannot be re-applied until review is complete.',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm Submit',
      pleaseSelectDevices: 'Please select devices to submit',
      appliedStatusWarning: 'Devices with applied status cannot be submitted',
      storeCloudSeparateWarning: 'Cloud warehouse and offline store devices must be submitted separately!',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Submission failed',
      queryFailed: 'Query failed',
      offlineStore: 'Offline Store',
      yuan: '¥',
      unit: 'units',
      applicantFormat: '{name} (ID {campusId})',
      statusUnapplied: 'Unapplied',
      statusAuditing: 'Auditing',
      statusAudited: 'Audited',
      statusCompleted: 'Completed',
      statusRejected: 'Rejected',
      statusCanceled: 'Canceled',
      columnSnCode: 'SN Code',
      columnWarehouse: 'Warehouse',
      columnModel: 'Model',
      columnInboundTime: 'Inbound Time',
      columnLevelAPrice: 'Level A Price',
      columnDiscount: 'Discount',
      columnDiscountedAmount: 'Discounted Amount (¥)',
      columnApplyStatus: 'Apply Status'
    },
    equipmentToOptionApply: {
      pageTitle: 'Inventory Equipment to Option Applications',
      applyNo: 'Application No.',
      pleaseEnterApplyNo: 'Enter application no.',
      applyStatus: 'Application Status',
      pleaseSelectApplyStatus: 'Select application status',
      applyTime: 'Application Time',
      to: 'To',
      applyDeviceNum: 'Device Count',
      totalOptionAmount: 'Total Option Amount (¥)',
      auditTime: 'Audit Time',
      rejectReason: 'Reject Reason',
      operation: 'Operation',
      cancel: 'Cancel',
      viewDetail: 'View Details',
      detailTitle: 'Application Device Details',
      exportDetail: 'Export Details',
      cancelDialogTitle: 'Confirm Cancel',
      cancelDialogContent: 'Once canceled, all devices in this option application will be released for activation. Confirm?',
      cancelSuccess: 'Canceled successfully',
      cancelFailed: 'Cancel failed',
      queryFailed: 'Query failed',
      detailQueryFailed: 'Detail query failed',
      total: 'Total',
      detailTotalAmount: 'Total Amount',
      statusAuditing: 'Auditing',
      statusAudited: 'Audited',
      statusCompleted: 'Completed',
      statusRejected: 'Rejected',
      statusCanceled: 'Canceled',
      columnIndex: '#',
      columnSnCode: 'SN Code',
      columnModel: 'Model',
      columnWarehouse: 'Warehouse',
      columnLevelAPrice: 'Level A Purchase Price (¥)',
      columnDiscount: 'Discount',
      columnDiscountedAmount: 'Discounted Amount (¥)'
    },
    accountBalanceToOptionApply: {
      pageTitle: 'Account Balance to Options',
      applyNo: 'Application No.',
      pleaseEnterApplyNo: 'Enter application no.',
      applyStatus: 'Application Status',
      pleaseSelectApplyStatus: 'Select application status',
      applyTime: 'Application Time',
      goldAccount: 'Gold Account',
      cashAccount: 'Cash Account',
      voucherAccount: 'Fission Account',
      withdrawalAccount: 'Withdrawal Account',
      totalAmount: 'Total Amount',
      auditTime: 'Audit Time',
      rejectReason: 'Reject Reason',
      operation: 'Operation',
      view: 'View',
      modify: 'Modify',
      cancel: 'Cancel',
      applyButton: 'Balance to Options',
      createTitle: 'Balance to Options Application',
      modifyTitle: 'Modify Balance to Options Application',
      viewTitle: 'View Balance to Options Application',
      account: 'Account',
      accountBalance: 'Current Available Balance',
      applyAmount: 'Transfer Amount',
      applyTotalAmount: 'Total Amount',
      applyDialogDesc: 'Select the accounts and amounts to transfer. Each account amount must not exceed the current available balance. Submit and wait for HQ review.',
      auditTip: 'After approval, the application amount will be deducted from each account and recharged to the option account automatically. Rejected applications will not deduct funds.',
      close: 'Cancel',
      confirm: 'Confirm',
      statusAuditing: 'Auditing',
      statusCompleted: 'Completed',
      statusCanceled: 'Canceled',
      statusRejected: 'Rejected',
      queryFailed: 'Query failed',
      balanceQueryFailed: 'Balance query failed',
      totalAmountRequired: 'Total amount must be greater than 0',
      amountOverAvailable: 'Transfer amount must not exceed the current available balance',
      submitSuccess: 'Submitted successfully',
      submitFailed: 'Submit failed',
      cancelSuccess: 'Canceled successfully',
      cancelFailed: 'Cancel failed',
      cancelDialogContent: 'Confirm canceling this balance to options application?'
    },
    // Monthly Bill - Status
    billStatusPending: "Pending Payment",
    billStatusPaid: "Paid",
    billStatusReviewing: "Pending Review",
    billStatusOverdue: "Overdue",
    billStatusRejected: "Rejected",
    // Monthly Bill - Detail
    monthlyBillDetail: "Monthly Bill Details",
    stepBillGenerated: "Bill Generated",
    stepUploadVoucher: "Upload Voucher",
    stepHqAudit: "HQ Review",
    stepPaid: "Paid",
    feeBreakdown: "Fee Breakdown",
    feeItem: "Fee Item",
    calcBasis: "Calculation Basis",
    feeAmount: "Amount",
    feeCategory: "Fee category",
    royaltyFeeGroupTitle: "Royalty Fee",
    marketingFeeGroupTitle: "Marketing Fee",
    royaltyFeeSubtotalLabel: "Royalty Fee Subtotal",
    feeLineMonthlyFixed: "① Monthly fixed fee",
    feeLineSupervision: "② Supervision{rateText}",
    feeLineNewRegFee: "③ New student registration",
    marketingFeeItemLine: "(Supervision + Reg.) × {rate}%",
    marketingFeeCalcLine: "({s} + {r}) × {p}%",
    studentsCountUnit: " students",
    newStudentsCountUnit: " new students",
    feeTotal: "Total",
    monthlyFixedCollection: "Monthly Fixed",
    supervisionStudentDetail: "Supervision Student Details",
    registrationStudentDetail: "Registration Student Details",
    supervisionStart: "Supervision Start",
    supervisionEnd: "Supervision End",
    supervisionResult: "Supervision Result",
    supervisionStatus: "Supervision Status",
    registrationTime: "Registration Time",
    deviceSN: "Device SN",
    accountStatusLabel: "Account Status",
    totalStudents: "Total {n} students",
    studentIdColumn: "Student ID",
    voucherListItem: "Voucher {n}",
    // Monthly Bill - Supervision fee standard (countryId + standardMatchType)
    supervisionFeeStandardPrefix: "Supervision fee standard: ",
    supervisionStandardHit: "Matched",
    supervisionStandardDealerExclusive: "Dealer ID exclusive standard",
    supervisionStandardTierProvinceCN: "Province standard",
    supervisionStandardTierCityCN: "City standard",
    supervisionStandardTierDistrictCN: "District standard",
    supervisionStandardTierStateUS: "State standard",
    supervisionStandardTierCountyUS: "County standard",
    supervisionStandardTierCityUS: "Municipal standard",
    supervisionStandardPerStudentMonth: "/student/mo",
    supervisionStandardCalcPart: "{n} effective supervision students × {unit} × {rate}% = {total}",
    // Monthly Bill - Payment
    paymentInfo: "Payment Info",
    submitPayment: "Submit Payment",
    uploadPaymentProof: "Upload Payment Proof",
    uploadTip1to5: "Upload 1-5 voucher files (JPG/PNG/PDF). Multiple files can be selected at once.",
    submitVoucherWaitAudit: "Submit & Await Review",
    uploadedVouchers: "Uploaded Vouchers",
    rejectReason: "Rejection Reason",
    paymentSubmitSuccess: "Payment voucher submitted successfully, please wait for review",
    pleaseUploadAtLeastOne: "Please upload at least one screenshot",
    maxUpload5Images: "Maximum 5 images allowed",
    onlyJpgPngAllowed: "Only JPG, JPEG, PNG, PDF files are allowed",
    imageSizeExceed5M: "File size cannot exceed 20MB",
    voucherVerified: "Voucher verified, no action needed",
    billAmount: "Bill Amount",
    payTimeLabel: "Payment Time",
    auditTimeLabel: "Review Time",
    billRemarkLabel: "Remark (Optional)",
    billRemarkPlaceholder: "Enter remark",
    pendingVoucherTip: "You have 1 bill in [Pending Payment]. Please complete bank wire transfer and upload the voucher before {date}. Overdue payment may affect supervision service usage.",
    paymentInstructionTitle: "Payment Instructions",
    paymentInstructionLine1: "Complete bank wire transfer ({amount}) before {date}",
    paymentInstructionLine2: "After transfer, upload the payment voucher below",
    paymentInstructionLine3: "HQ will update the bill status after review",
    paymentInstructionLine4: "Overdue payment may affect supervision service usage",
  },
  financeCenter: {
    valuation: "Valuation",
    auto_1_6b6ece34: "Payment1",
    auto_1_ebc377a4: "Submission Failed1",
    auto_2_745edc9e: "Update2",
    auto_2_d4954d6e: "Write-off Master Franchisee2",
    auto_3_9187db9b: "Write-off Master Franchisee Name3",
    auto_3_ea766e30: "Invoice Confirmation3",
    auto_4_7027499f: "Transaction ID4",
    auto_4_e82041b8: "More4",
    auto_5_6f265697: "Cancel5",
    auto_5_cf628124: "Write-off Amount5",
    auto_6_3682d1dc: "Submit6",
    auto_6_dca8bab5: "Issued Master Franchisee6",
    auto_7_6f63d67e: "Issued Master Franchisee Name7",
    auto_7_c4ce0715: "Change Address7",
    auto_8_92d398e1: "Receipt Confirmation8",
    auto_8_fb1e1ec8: "Write-off Order8",
    auto_9_4334790a: "Linked Master Franchisee9",
    auto_9_729212dd: "Actions9",
    auto_10_0d0eb47b: "Linked Master Franchisee Name10",
    auto_10_a9f42805: "Payment10",
    auto_11_19f35b07: "Update11",
    auto_11_5d8b94fd: "Write-off Time11",
    auto_12_7a1e0aea: "Write-off By12",
    auto_12_9a934775: "Invoice Confirmation12",
    auto_13_797c0418: "Notes13",
    auto_13_df7b22b8: "More13",
    auto_14_1162996f: "Actions14",
    auto_14_88429bf5: "Associated Master Franchisee14",
    auto_15_884eec7f: "Associated Master Franchisee Name15",
    auto_15_d6f54305: "Payment15",
    auto_16_28b64976: "Transaction ID16",
    auto_16_fb8dd9be: "Update16",
    auto_17_aad90013: "Voucher Amount17",
    auto_17_c660f5e5: "Invoice Confirmation17",
    auto_18_469e30df: "Issued Master Franchisee18",
    auto_18_67962858: "More18",
    auto_19_1a2b2e88: "Actions19",
    auto_19_3b689608: "Issued Master Franchisee Name19",
    auto_20_16677134: "Payment20",
    auto_20_c8ded2b2: "Purchase Order20",
    auto_21_68c0645e: "Received Time21",
    auto_21_c37f7ef2: "Update21",
    auto_22_78fb43d0: "Expiration Time22",
    auto_22_b82fc983: "Invoice Confirmation22",
    auto_23_4434e40c: "More23",
    auto_23_4cc548ab: "Notes23",
    auto_24_1f4283f9: "Associated Master Franchisee24",
    auto_24_f4c2d691: "Actions24",
    auto_25_0e997a9f: "Cancel25",
    auto_25_5194ce27: "Associated Master Franchisee Name25",
    auto_26_c44a0dff: "Financial Confirmation26",
    auto_26_f87a9ffd: "Transaction ID26",
    auto_27_b1784121: "Bound Order Recharge ID27",
    auto_27_b3b45e9e: "Voucher Usage Amount27",
    auto_28_41f30956: "Issued Master Franchisee28",
    auto_29_8255c8cb: "Issued Master Franchisee Name29",
    auto_30_8cbda33e: "Purchase Order30",
    auto_31_4c4fdf72: "Linked Master Franchisee31",
    auto_32_d8363811: "Linked Master Franchisee Name32",
    auto_33_8c1fbd78: "Issued Time33",
    auto_34_37f1b74c: "User34",
    auto_34_d0862854: "Payment34",
    auto_35_155cd631: "Issuance Notes35",
    auto_35_ce7a09eb: "Details35",
    auto_36_a15a703b: "Usage Notes36",
    auto_36_e8c4a85c: "Inventory Cash Value36",
    auto_37_2057c69a: "Transaction ID37",
    auto_37_55a03750: "Please prioritize submitting a red invoice issued by Squirrel Ai. If unavailable, submit existing unbilled purchase records37",
    auto_38_bb8b4786: "Usage Quantity38",
    auto_39_9e95e46b: "Usage Time39",
    auto_39_e3ee3b18: "Demo Device Policy & Guidelines39",
    auto_40_a8a43348: "Test Logistics40",
    auto_40_bafe5d5f: "Usage Account40",
    auto_41_65ec2f30: "Student Name41",
    auto_42_4711b9cd: "Student Account42",
    auto_43_fd6f12d4: "Operator43",
    directFinReportMonth: "Associated Month",
    directFinReportCampusId: "Joint Store ID",
    directFinReportCampusName: "Joint Store Name",
    directFinReportType: "Report Type",
    directFinReportStatus: "Status",
    directFinReportAuditStatus: "Audit Status",
    directFinReportAuditName: "Auditor",
    directFinReportAuditTime: "Audit Time",
    directFinReportAuditRemark: "Audit Opinion",
    directFinReportUploadName: "Uploaded By",
    directFinReportUploadTime: "Upload Time",
    directFinReportOriginalFile: "File Name",
    directFinReportFileSize: "File Size",
    directFinReportRemark: "Remark",
    directFinReportDownloadTemplate: "Download Templates",
    directFinReportTemplateDialogTitle: "Download Templates",
    directFinReportTemplateVersion: "Template Version",
    directFinReportTemplateFile: "Template File",
    directFinReportDownloadAllTemplate: "Download All Templates",
    directFinReportUpload: "Upload",
    directFinReportReupload: "Re-upload",
    directFinReportFile: "Report File",
    directFinReportUploadTip: "Drop an Excel file here, or click to upload",
    directFinReportExcelOnly: "Only xls/xlsx files are supported",
    directFinReportOnlyOneFile: "Only one report file can be uploaded",
    directFinReportConfirmUpload: "Confirm Upload",
    directFinReportUploadSuccess: "Uploaded successfully, pending audit",
    directFinReportValidationFailed: "Report validation failed. Please check details.",
    directFinReportDetailTitle: "Financial Report Detail",
    directFinReportBaseInfo: "Base Info",
    directFinReportValidationResult: "Validation Result",
    directFinReportData: "Report Data",
    directFinReportDownloadReport: "Download Report",
    directFinReportOperateLog: "Operation Logs",
    directFinReportOperateType: "Operation Type",
    directFinReportOperateContent: "Operation Content",
    directFinReportOperateName: "Operator",
    directFinReportOperateTime: "Operation Time",
    directFinReportCellRef: "Cell",
    directFinReportFieldName: "Field",
    directFinReportErrorMessage: "Error",
    directStoreReceiptRecord: "直营店收款记录",
    directStoreFlowNo: "流水编号",
    directStoreFlowNoPlaceholder: "请输入流水编号",
    directStoreFlowType: "流水类型",
    directStoreFlowTypePlaceholder: "请选择流水类型",
    directStoreRelatedOrderNo: "关联单号",
    directStoreParentInfo: "家长信息",
    directStoreParentInfoPlaceholder: "请输入家长姓名或手机号",
    directStorePayMethodPlaceholder: "请选择支付方式",
    directStorePayMethodVoucher: "上传凭证",
    directStorePayMethodAggregate: "汇付天下",
    directStoreTransactionTime: "交易时间",
    directStoreRangeTo: "至",
    directStoreReceiptRecordQueryFailed: "直营店收款记录查询失败",
    parentName: "家长姓名",
    parentPhone: "家长手机号",
    amountYuan: "金额（元）",
    receipt: "收款",
    refund: "退款",
    attachment: "附件",
    attachmentPreview: "附件预览",
    noAttachment: "无附件",
    pleaseSelectReportMonth: "Please select associated month",
    pleaseSelectReportType: "Please select report type",
    pleaseSelectReportStatus: "Please select upload status",
    pleaseSelectReportFile: "Please select report file",
    auto_44_39032079: "Notes44",
    auto_45_1f40693b: "Transaction ID45",
    auto_46_73372523: "Acquired Quantity46",
    auto_47_2c39e54a: "Acquisition Method47",
    auto_48_53c95de1: "Acquisition Time48",
    auto_49_3ebd895a: "Acquired By49",
    auto_50_689c2aaf: "Operator50",
    auto_51_1a4fb740: "Notes51",
    auto_52_d17a4725: "John Doe52",
    auto_53_28a9915d: "Los Angeles53",
    auto_54_d648a147: "Downtown54",
    auto_55_5f6611f6: "123 Main St, Los Angeles 55",
    auto_56_3ee2dbc5: "John Doe56",
    auto_57_2451d523: "Los Angeles57",
    auto_58_ca225558: "Downtown58",
    auto_59_2d6a5ca7: "123 Main St, Los Angeles 59",
    auto_60_898bbf9d: "John Doe60",
    auto_61_97f5b154: "Los Angeles61",
    auto_62_56cec1b0: "Downtown62",
    auto_63_f7968f67: "123 Main St, Los Angeles 63",
    auto_64_f6b2ed60: "John Doe64",
    auto_65_3de41d78: "Los Angeles65",
    auto_66_7c5347c4: "Downtown66",
    auto_67_6b0e8395: "123 Main St, Los Angeles 67",
    auto_68_5d335e58: "John Doe68",
    auto_69_f87aa3f3: "Los Angeles69",
    auto_70_b2bc7a8e: "Downtown70",
    auto_71_49370797: "123 Main St, Los Angeles 71",
    auto_72_ee82bb93: "John Doe72",
    auto_73_957bbacc: "Los Angeles73",
    auto_74_8d817d9c: "Downtown74",
    auto_75_a57308c1: "123 Main St, Los Angeles 75",
    auto_76_0ef701f3: "John Doe76",
    auto_77_596b3f41: "Los Angeles77",
    auto_78_26a95388: "Downtown78",
    auto_79_66e61787: "123 Main St, Los Angeles 79",
    auto_80_ef2308ce: "John Doe80",
    auto_81_816335b0: "Los Angeles81",
    auto_82_5093ffa7: "Downtown82",
    auto_83_cec78619: "123 Main St, Los Angeles 83",
    auto_84_06813cd6: "Transaction ID84",
    auto_85_6d496bf0: "Operation Quantity85",
    auto_86_a845dd6a: "Transfer-out Time86",
    auto_87_3cfcfaf4: "Transfer-out Account87",
    auto_88_7c8ab76b: "Transfer-in Account88",
    auto_89_c114f60c: "Operator89",
    auto_90_18862e79: "Notes90",
    auto_91_05b422f9: "Master Franchisee91",
    auto_92_28409628: "Master Franchisee Name92",
    auto_93_56609012: "Gold Account Balance93",
    auto_94_e17c9a8e: "Cash Account Balance94",
    auto_95_82ecdc81: "Voucher Balance95",
    auto_97_7a3becf5: "Store Visit Address97",
    auto_98_38685431: "Check-in Time98",
    auto_99_73621379: "Visited Franchisee99",
    auto_100_cb775405: "Visited Franchisee Name100",
    auto_101_1fd8d725: "Store101",
    auto_102_f3526d82: "Check-in Time102",
    auto_103_0dd369f2: "Store Visit Address103",
    auto_104_3f064d4d: "Linked Master Franchisee104",
    auto_105_73f5d318: "Linked Master Franchisee Name105",
    auto_106_72c70ecf: "Transaction ID106",
    auto_107_ea502f26: "Voucher Amount107",
    auto_108_65a5c8a5: "Issued Master Franchisee108",
    auto_109_12710029: "Issued Master Franchisee Name109",
    auto_110_67642bea: "Purchase Order110",
    auto_111_a2375f4e: "Issued Time111",
    auto_112_e9efec21: "Issued By112",
    auto_113_a2269a72: "Notes113",
    auto_114_eb8a1b4d: "(Advance Allocation)",
    auto_116_18891eb0: "Master Franchisee116",
    auto_117_e20fb753: "Confirmed117",
    auto_118_5a6ea357: "Remaining Unordered Amount118",
    auto_119_10de635d: "Individual119",
    auto_120_7f351f27: "Company120",
    auto_121_dae829e2: "Unread121",
    auto_122_f2d5d8b1: "Recharge122",
    auto_123_72c869d7: "Recharge123",
  },
};
